import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 基本状态
    sidebar: {
      opened: true
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  },
  getters: {
    sidebar: state => state.sidebar,
    token: state => state.user.token || '',
    userInfo: state => state.user.userInfo || {},
    name: state => state.user.name || '',
    roles: state => Array.isArray(state.user.roles) ? state.user.roles : [],
    permissions: state => Array.isArray(state.user.permissions) ? state.user.permissions : [],
    routes: state => Array.isArray(state.permission.routes) ? state.permission.routes : [],
    addRoutes: state => Array.isArray(state.permission.addRoutes) ? state.permission.addRoutes : []
  },
  modules: {
    user,
    permission
  }
})

export default store